import { Component, Input } from '@angular/core';
import { StatusAlert } from './assessment-status-alert.model';
import { AlertComponent } from '../../../alert/alert.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-assessment-status-alerts',
  template: `
    <section>
      @for (alert of alerts; track alert) {
      <sibat-alert class="sibat-alert" [type]="alert.type">
        {{ alert.messageKey | transloco }}
      </sibat-alert>
      }
    </section>
  `,
  styleUrls: ['assessment-status-alert.scss'],
  imports: [AlertComponent, TranslocoPipe],
})
export class AssessmentStatusAlertsComponent {
  @Input() alerts: StatusAlert[];
}
